import EditIcon from "../../../../../assets/icons/edit-action-icon.svg";
import ArchiveIcon from "../../../../../assets/icons/archive.svg"

export const headers = [
  { key: "serviceName", label: "Service Name" },
  { key: "category", label: "Category" },
  { key: "basePrice", label: "Base Price" },
  { key: "serviceCode", label: "Service Code" },
  { key: "status", label: "Status" },
  { key: "action", label: "Action" },
];

export const actionOptions = [
  {
    label: "Edit",
    value: "edit",
    id: 1,
    disabled: false,
    tooltipText: "",
    src: EditIcon,
  },
  {
    label: "Archive",
    value: "archive",
    id: 2,
    disabled: false,
    tooltipText: "",
    src: ArchiveIcon,
  }
];  

export const servicesDummyData = [
  {
    id: 1,
    serviceName: "Website Development",
    serviceCode: "SRV001",
    category: "IT Services",
    basePrice: 50000,
    status: "Active"
  },
  {
    id: 2,
    serviceName: "Mobile App Development",
    serviceCode: "SRV002",
    category: "IT Services",
    basePrice: 80000,
    status: "Approved"
  },
  {
    id: 3,
    serviceName: "UI/UX Design",
    serviceCode: "SRV003",
    category: "Design",
    basePrice: 30000,
    status: "Active"
  },
  {
    id: 4,
    serviceName: "SEO Optimization",
    serviceCode: "SRV004",
    category: "Marketing",
    basePrice: 20000,
    status: "Inactive"
  },
  {
    id: 5,
    serviceName: "Digital Marketing",
    serviceCode: "SRV005",
    category: "Marketing",
    basePrice: 45000,
    status: "Approved"
  },
  {
    id: 6,
    serviceName: "Cloud Migration",
    serviceCode: "SRV006",
    category: "Cloud",
    basePrice: 90000,
    status: "Active"
  },
  {
    id: 7,
    serviceName: "AWS Support",
    serviceCode: "SRV007",
    category: "Cloud",
    basePrice: 60000,
    status: "Inactive"
  },
  {
    id: 8,
    serviceName: "DevOps Setup",
    serviceCode: "SRV008",
    category: "DevOps",
    basePrice: 70000,
    status: "Approved"
  },
  {
    id: 9,
    serviceName: "API Development",
    serviceCode: "SRV009",
    category: "Backend",
    basePrice: 40000,
    status: "Active"
  },
  {
    id: 10,
    serviceName: "Microservices Architecture",
    serviceCode: "SRV010",
    category: "Backend",
    basePrice: 100000,
    status: "Approved"
  },
  {
    id: 11,
    serviceName: "QA Automation",
    serviceCode: "SRV011",
    category: "Testing",
    basePrice: 35000,
    status: "Active"
  },
  {
    id: 12,
    serviceName: "Manual Testing",
    serviceCode: "SRV012",
    category: "Testing",
    basePrice: 20000,
    status: "Inactive"
  },
  {
    id: 13,
    serviceName: "Data Analysis",
    serviceCode: "SRV013",
    category: "Data",
    basePrice: 55000,
    status: "Approved"
  },
  {
    id: 14,
    serviceName: "AI Model Integration",
    serviceCode: "SRV014",
    category: "AI",
    basePrice: 120000,
    status: "Active"
  },
  {
    id: 15,
    serviceName: "Chatbot Development",
    serviceCode: "SRV015",
    category: "AI",
    basePrice: 65000,
    status: "Approved"
  },
  {
    id: 16,
    serviceName: "CRM Implementation",
    serviceCode: "SRV016",
    category: "Enterprise",
    basePrice: 75000,
    status: "Inactive"
  },
  {
    id: 17,
    serviceName: "ERP Customization",
    serviceCode: "SRV017",
    category: "Enterprise",
    basePrice: 110000,
    status: "Active"
  },
  {
    id: 18,
    serviceName: "Performance Optimization",
    serviceCode: "SRV018",
    category: "Optimization",
    basePrice: 48000,
    status: "Approved"
  },
  {
    id: 19,
    serviceName: "Security Audit",
    serviceCode: "SRV019",
    category: "Security",
    basePrice: 52000,
    status: "Active"
  },
  {
    id: 20,
    serviceName: "Penetration Testing",
    serviceCode: "SRV020",
    category: "Security",
    basePrice: 68000,
    status: "Inactive"
  }
];

